import { combineReducers } from "redux";
import user_metadata from "./metaDataReducer";

const rootReducers = combineReducers({
  user_metadata,
});

export default rootReducers;
